<template>
  <div>
    <breadcrumb/>
    <v-layout row wrap>
      <v-flex xs12 pt-2>
        <p class="headline">¿Con quién me comunico si...?</p>
      </v-flex>
      <v-flex xs12>
        <v-form>
          <v-text-field
            id="query"
            v-model="query"
            xs12
            solo
            placeholder="Busque aquí, ejemplo: anexo"
          ></v-text-field>
        </v-form>
      </v-flex>
      <v-flex v-for="faq in filteredAnswers" :key="faq.id" xs12>
        <p class="title">{{faq.question}}</p>
        <p class="subheading">{{faq.answer}}</p>
        <hr>
        <br>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/General/Breadcrumb";
export default {
  data() {
    return {};
  },
  components: {
    Breadcrumb
  },
  computed: {
    ...mapGetters(["filteredAnswers"]),
    query: {
      get() {
        return this.$store.state.filter.query.toLowerCase();
      },
      set(value) {
        this.$store.commit("setFilter", {
          filter: "query",
          value
        });
      }
    }
  }
};
</script>